export const PIPELINE_LAYERS_STARTS = {
  LAYER: "layer_",
  LAYER_HIT: "layer_hit_",
  LAYER_POINTS: "layer_points_",
  POINTS: "points_",
} as const;

export const PIPELINE_LAYERS_TYPES = {
  LINE: "line",
  CIRCLE: "circle",
} as const;
